import { render, staticRenderFns } from "./vgpButton.vue?vue&type=template&id=1f6224d5&scoped=true&"
import script from "./vgpButton.vue?vue&type=script&lang=js&"
export * from "./vgpButton.vue?vue&type=script&lang=js&"
import style0 from "./globalButton.less?vue&type=style&index=0&id=1f6224d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6224d5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f6224d5')) {
      api.createRecord('1f6224d5', component.options)
    } else {
      api.reload('1f6224d5', component.options)
    }
    module.hot.accept("./vgpButton.vue?vue&type=template&id=1f6224d5&scoped=true&", function () {
      api.rerender('1f6224d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/common/VueComponents/globalButton/vgpButton.vue"
export default component.exports